import { Component } from '@angular/core';
import globalVariable from "../globalVariable/globalVariable.json"

@Component({
    selector: 'app-footer',
    templateUrl:'./app.footer.component.html'
})
export class AppFooterComponent {
    mobileNumber: any;
    emailAddress: any;
    lang = "en";
    phoneCopied: boolean = false;
    copyTooltipText: string = "Copy number";
    emailCopied: boolean = false;
    emailCopyTooltipText: string = "Copy email";

    en = {
        "poweredByLabel": "Powered By",
        "phone:Label": "Phone:",
        "email:Label": "Email:",
        "knowAboutTecGymLabel":"Know more about TecGym.",
        "numberCopiedLabel":"Number Copied!",
        "emailCopiedLabel":"Email Copied!",
    }
    ar = {
        "poweredByLabel": "مشغل بواسطة",
        "phone:Label": "هاتف:",
        "Email:Label": "بريد إلكتروني:",
        "knowAboutTecGymLabel":"اعرف المزيد عن TecGym.",
        "numberCopiedLabel":"تم نسخ الرقم!",
        "emailCopiedLabel":"تم نسخ البريد الإلكتروني!",

    }
    ur = {
        "poweredByLabel": "کی طرف سے طاقت",
        "phone:Label": "فون:",
        "email:Label": "ای میل:",
        "knowAboutTecGymLabel":"TecGym کے بارے میں مزید جانیں۔",
        "numberCopiedLabel":"نمبر کاپی ہو گیا!",
        "emailCopiedLabel":"ای میل کاپی ہو گیا!",

    }
    ps = {
        "poweredByLabel": "د",
        "phone:Label": "تلیفون له لارې:",
        "email:Label": "بریښنالیک:",
        "knowAboutTecGymLabel":"د TecGym په اړه نور معلومات ترلاسه کړئ.",
        "numberCopiedLabel":"شمېره کاپي شوه!",
        "emailCopiedLabel":"برېښنالیک کاپي شو!",

    }
    setLabel(label) {
        if (this.lang === "en") {
            return this.en[label];

        }
        else if (this.lang === "ar") {
            return this.ar[label];

        }

    }
    constructor() { }

    ngOnInit(){
        this.mobileNumber = globalVariable.suportInfo.mobile;
        this.emailAddress = globalVariable.suportInfo.email;
    }

    get formattedMobileNumber() {
        if (!this.mobileNumber) return '';
        // Remove +, -, and spaces for WhatsApp URL
        return this.mobileNumber.replace(/[+\-\s]/g, '');
    }

    copyMobileNumberToClipboard() {
        if (this.mobileNumber) {
            navigator.clipboard.writeText(this.mobileNumber).then(() => {
                this.phoneCopied = true;
                this.copyTooltipText = "Number Copied";
                setTimeout(() => {
                    this.phoneCopied = false;
                    this.copyTooltipText = "Copy Number";
                }, 2000);
            });
        }
    }

    copyEmailToClipboard() {
        if (this.emailAddress) {
            navigator.clipboard.writeText(this.emailAddress).then(() => {
                this.emailCopied = true;
                this.emailCopyTooltipText = "Email Copied";
                setTimeout(() => {
                    this.emailCopied = false;
                    this.emailCopyTooltipText = "Copy Email";
                }, 2000);
            });
        }
    }
}
